/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ExperienceExportIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Experience Export',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M30 28H12v-4h7.6v-2H12v-4h7.6v-2H4V8h26V5a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1Zm-20 0H4V18h6Z"
    />
    <path
      d="M28 14v-3.328a.5.5 0 0 1 .866-.341L36 18l-7.134 7.669a.5.5 0 0 1-.866-.341V22h-5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1Z"
    />
  </svg>`;
};
